import ArticleCard from 'components/Globals/ArticleCard';
import useBreakpoint from 'hooks/useBreakpoint';
import type { ArticlePreview } from 'interfaces/content/articles/Articles';
import { renderListWithAds } from 'components/Grid/ArticleGrid/ArticleGrid';
import { PageType } from 'interfaces/content/articles/Post';
import * as S from './ArticleSectionStyles';
import type { JSX } from 'react';
import getCommonTestId from 'constants/testsIds/common';

interface ArticleSectionProps {
  latestArticles: ArticlePreview[];
  contentWithAd: JSX.Element[];
  sponsor?: boolean;
}

const ArticleSection: React.FC<ArticleSectionProps> = ({
  latestArticles,
  contentWithAd,
  sponsor,
}: ArticleSectionProps) => {
  const isMdMin = useBreakpoint('mdMin');
  const isMobile = useBreakpoint('mdMax');
  const isDesktop = useBreakpoint('lgMin');

  const trackingdata = {
    contentPlacementCD: 'homepage sections',
    eventAction: 'feature article click',
    eventCategory: 'navigation',
  };

  const [featureArticle, ...articles] = latestArticles;
  const contentWithoutFeature = contentWithAd.slice(1, 6);

  return (
    <S.FeatureArticleWrapper>
      <ArticleCard
        article={featureArticle}
        layoutVariant='card-xl'
        className='hero-article-card section-article-card no-eyebrow'
        trackingData={trackingdata}
        titleSize={{ default: 'level6', smMin: 'level3' }}
        priority
      />

      {isMdMin !== undefined && (
        <S.ArticleList data-cy={getCommonTestId('TOPIC_PAGE_LATEST_ARTICLE_LIST')}>
          {sponsor
            ? renderListWithAds(contentWithoutFeature, 1, false, PageType.SECTION, isMobile, isDesktop)
            : articles.map((article) => (
                <ArticleCard
                  key={article.databaseId}
                  article={article}
                  layoutVariant={isMdMin ? 'card-xxs' : 'card-xl'}
                  className='sections-small-card no-eyebrow'
                  trackingData={trackingdata}
                  titleSize={{ default: 'level6', smMin: 'level6' }}
                />
              ))}
        </S.ArticleList>
      )}
    </S.FeatureArticleWrapper>
  );
};

export default ArticleSection;
